import React from "react";
import styled from "styled-components";
import { flexbox, FlexboxProps, layout, LayoutProps, space, SpaceProps } from "styled-system";
import { Title } from "../Title";

export interface ImageProps {
  alt: string;
  src: string;
  title?: string;
}

const Component = styled.img<any>`
  ${flexbox}
  ${layout}
  ${space}
  max-width: 100%;
`;

export const Image: React.FC<ImageProps & FlexboxProps & LayoutProps & SpaceProps> = ({ title, ...rest }) => {
  return (
    <>
      {title && (
        <Title as="h2" mb="24px">
          {title}
        </Title>
      )}
      <Component {...rest} />
    </>
  );
};
